import React, { useState, useEffect } from 'react';
import { ArrowLeft, Save, Plus, Trash2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';

import { getNewLoadList, createNewLoad } from '@/redux/Load/actions';

const LoadPlanForm = ({ onBack, planData = null }) => {
    const [items, setItems] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [selectAll, setSelectAll] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;
    const { newLoadList } = useSelector((state) => state.load);
    const dispatch = useDispatch();
    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");
    const authName = authUser?.username;
    const companyId=authUser?.companyId;

    useEffect(() => {
        _getLoadList(1);
    }, [searchText]);

    useEffect(() => {
        setItems(newLoadList?.data || []);
    }, [newLoadList]);


    const _getLoadList = async (page = 1) => {
        setCurrentPage(page);
        const payload = {
            IPageNo: page, IPageRecords: recordsPerPage, FromDate: '', ToDate: '', SearchKeyword: searchText,
            compnayId:companyId
        }
        await dispatch(getNewLoadList(payload));
    }

    const handlePrevious = () => {
        if (currentPage > 1) _getLoadList((prev) => prev - 1);
    };

    const handleNext = () => {
        if (pagination?.nextPage > 0) _getLoadList(pagination.nextPage);
    };

    const handleItemChange = (index, field, value) => {
        const updated = [...items];
        updated[index][field] = value;
        if (field === 'loadingUnit') {
            updated[index][field] = parseFloat(value);
            const casesPerUnit = parseFloat(updated[index].casesCount) || 0;
            const remainingUnit = parseFloat(updated[index].remainingUnit) || 0;
            updated[index].loadingCases = (parseFloat(value) * casesPerUnit);
            // updated[index].remainingUnit = parseFloat(remainingUnit - value);
        }
        console.log('Updated Item:', updated);
        setItems(updated);
    };

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        setItems(items.map(item => ({ ...item, select: checked })));
    };

    const handleSelectItem = (index) => {
        const updated = [...items];
        updated[index].select = !updated[index].select;
        setItems(updated);
        setSelectAll(updated.every(item => item.select));
    };

    const addItem = () => {
        setItems([...items, {
            id: items.length + 1,
            sno: items.length + 1,
            select: false,
            soId: '',
            sku: '',
            totalContUnit: '0.00',
            remainingContUnit: '0.00',
            loadingUnit: '',
            casesPerUnit: '0.00',
            totalCases: '0.00',
            remainingCases: '0.00',
            loadingCases: '',
            totalQty: '0.00',
            uom: 'Case',
            packing: '0',
            packingUnit: 'TON',
            linkPoItem: ''
        }]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let selectedItems = items.filter(item => item.select);
        if (selectedItems.length === 0) {
            alert('Please select at least one item to create a load plan.');
            return;
        }
        let selectedPonumber = items.filter(item => item.select && (item?.poNumberSelected === '' || item?.poNumberSelected == null));
        if (selectedPonumber.length > 0) {
            alert('Please select PO Number for all selected items.');
            return;
        }
        console.log('Load Plan Data:', items);
        await Promise.all(items.map(async item => {
            if (item.select) {
                const payload = {
                    "soId": item?.salesorderId,
                    "soLineitemId": item?.salesorderLineitemId,
                    "soNumber": item?.salesordernumber,
                    "poNumber": item?.poNumberSelected,
                    "sku": item?.sku,
                    "quantity": item?.loadingUnit,
                    "createdBy": "admin"
                }
                console.log('Payload:', payload);
                const dd = await createNewLoad(payload);
            }
        }));
        window.location.reload();
    };

    return (
        <div className="h-full bg-slate-50 dark:bg-slate-950 overflow-y-auto">
            <div className="w-full px-6 py-6">
                {/* Compact Header */}
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                        <button
                            onClick={onBack}
                            className="p-2 hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg transition-colors"
                        >
                            <ArrowLeft className="w-5 h-5 text-slate-600 dark:text-slate-400" />
                        </button>
                        <div>
                            <h1 className="text-xl font-bold text-slate-900 dark:text-white">
                                {planData ? 'Edit Load Plan' : 'New Load Plan'}
                            </h1>
                            <p className="text-xs text-slate-500 dark:text-slate-400">
                                {planData ? `Editing ${planData.id}` : 'Create a new load plan'}
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center space-x-2">
                        <button
                            type="button"
                            onClick={onBack}
                            className="px-4 py-2 text-sm text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg transition-all"
                        >
                            Cancel
                        </button>
                        {/* <button
                            type="button"
                            onClick={addItem}
                            className="px-4 py-2 text-sm bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                        >
                            <Plus className="w-4 h-4" />
                            <span>Add Item</span>
                        </button> */}
                        <button
                            type="submit"
                            form="lp-form"
                            className="px-4 py-2 text-sm bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                        >
                            <Save className="w-4 h-4" />
                            <span>Save Load Plan</span>
                        </button>
                    </div>
                </div>

                <form id="lp-form" onSubmit={handleSubmit} className="space-y-4">
                    {/* Load Plan Items Table */}
                    <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full text-xs">
                                <thead>
                                    <tr className="border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50">
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">S.NO</th>
                                        <th className="px-2 py-2 text-left">
                                            <input
                                                type="checkbox"
                                                checked={selectAll}
                                                onChange={handleSelectAll}
                                                className="rounded border-slate-300 text-[#0072FF] focus:ring-[#0072FF]"
                                            />
                                        </th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">SO ID</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">SKU</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">TOTAL CONT UNIT</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">REMAINING CONT UNIT</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">LOADING UNIT</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">CASES PER UNIT</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">TOTAL CASES</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">REMAINING CASES</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">LOADING CASES</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">TOTAL QTY</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">UOM</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">PACKING</th>
                                        <th className="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400">LINK PO ITEM</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                                    {items?.map((item, index) => (
                                        <tr key={item.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/30">
                                            <td className="px-2 py-2 text-slate-600 dark:text-slate-400">{item?.rowNum}</td>
                                            <td className="px-2 py-2">
                                                <input
                                                    type="checkbox"
                                                    checked={item?.select}
                                                    onChange={() => handleSelectItem(index)}
                                                    className="rounded border-slate-300 text-[#0072FF] focus:ring-[#0072FF]"
                                                />
                                            </td>
                                            <td className="px-2 py-2">
                                                <span className="text-xs text-slate-700 dark:text-slate-300">{item?.salesordernumber}</span>
                                            </td>
                                            <td className="px-2 py-2">
                                                <span className="text-xs font-mono text-slate-700 dark:text-slate-300">{item?.sku}</span>
                                            </td>
                                            <td className="px-2 py-2">
                                                <span className="text-xs text-slate-700 dark:text-slate-300">{item?.uot}</span>
                                            </td>
                                            <td className="px-2 py-2">
                                                <span className="text-xs text-slate-700 dark:text-slate-300">{item?.remainingUnit}</span>
                                            </td>
                                            <td className="px-2 py-2">
                                                <input
                                                    type="number"
                                                    max={item?.remainingUnit ?? ''}
                                                    min={0}
                                                    value={item?.loadingUnit}
                                                    onChange={(e) => item?.remainingUnit >= e.target.value ? handleItemChange(index, 'loadingUnit', e.target.value) : null}
                                                    className="w-20 px-2 py-1 text-xs border border-slate-300 dark:border-slate-700 rounded bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF]"
                                                />
                                            </td>
                                            <td className="px-2 py-2">
                                                <span className="text-xs text-slate-700 dark:text-slate-300">{item?.casesPerUot}</span>
                                            </td>
                                            <td className="px-2 py-2">
                                                <span className="text-xs text-slate-700 dark:text-slate-300">{item?.casesCount}</span>
                                            </td>
                                            <td className="px-2 py-2">
                                                <span className="text-xs text-slate-700 dark:text-slate-300">{item?.remainingCases}</span>
                                            </td>
                                            <td className="px-2 py-2">
                                                <input
                                                    type="number"
                                                    readOnly
                                                    value={item?.loadingCases}
                                                    onChange={(e) => handleItemChange(index, 'loadingCases', e.target.value)}
                                                    className="w-20 px-2 py-1 text-xs border border-slate-300 dark:border-slate-700 rounded bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF]"
                                                />
                                            </td>
                                            <td className="px-2 py-2">
                                                <span className="text-xs text-slate-700 dark:text-slate-300">{item?.quantity}</span>
                                            </td>
                                            <td className="px-2 py-2">
                                                <select
                                                    value={item?.uom}
                                                    onChange={(e) => handleItemChange(index, 'uom', e.target.value)}
                                                    className="w-20 px-1 py-1 text-xs border border-slate-300 dark:border-slate-700 rounded bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF]"
                                                >
                                                    <option>Case</option>
                                                    <option>Pallet</option>
                                                    <option>Box</option>
                                                    <option>Unit</option>
                                                </select>
                                            </td>
                                            <td className="px-2 py-2">
                                                <div className="flex items-center space-x-1">
                                                    <input
                                                        type="text"
                                                        value={item?.packing}
                                                        onChange={(e) => handleItemChange(index, 'packing', e.target.value)}
                                                        className="w-12 px-2 py-1 text-xs border border-slate-300 dark:border-slate-700 rounded bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF]"
                                                    />
                                                    <select
                                                        value={item?.metricType}
                                                        onChange={(e) => handleItemChange(index, 'metricType', e.target.value)}
                                                        className="w-16 px-1 py-1 text-xs border border-slate-300 dark:border-slate-700 rounded bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF]"
                                                    >
                                                        <option>TON</option>
                                                        <option>KG</option>
                                                        <option>LB</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td className="px-2 py-2">
                                                <select
                                                    value={item?.poNumberSelected}
                                                    onChange={(e) => handleItemChange(index, 'poNumberSelected', e.target.value)}
                                                    className="w-16 px-1 py-1 text-xs border border-slate-300 dark:border-slate-700 rounded bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF]"
                                                >
                                                    <option key="" value="">Select PO Item</option>
                                                    {
                                                        item?.poNumbers?.map((poItem, poIndex) => (
                                                            <option key={poIndex} value={poItem?.poNumber} disabled={parseFloat(poItem?.poUnits) === 0}>{poItem?.poNumber} (QTY: {parseFloat(poItem?.poUnits).toFixed(2)})</option>
                                                        ))
                                                    }
                                                </select>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className="border-t border-slate-200 dark:border-slate-800 px-4 py-3 flex items-center justify-between bg-slate-50 dark:bg-slate-800/50">
                            <div className="text-sm text-slate-600 dark:text-slate-400">
                                Showing <span className="font-medium">{items.length}</span> items
                            </div>
                            <div className="flex items-center space-x-2">
                                <button type="button" className="px-3 py-1 text-sm border border-slate-300 dark:border-slate-700 rounded hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-50" disabled>
                                    &lt;&lt;
                                </button>
                                <button type="button" className="px-3 py-1 text-sm border border-slate-300 dark:border-slate-700 rounded hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-50" disabled>
                                    &lt;
                                </button>
                                <span className="text-sm text-slate-600 dark:text-slate-400">Page 1 of 1</span>
                                <button type="button" className="px-3 py-1 text-sm border border-slate-300 dark:border-slate-700 rounded hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-50" disabled>
                                    &gt;
                                </button>
                                <button type="button" className="px-3 py-1 text-sm border border-slate-300 dark:border-slate-700 rounded hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-50" disabled>
                                    &gt;&gt;
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoadPlanForm;
